const quizTypes = [
  {
    // value: "any",
    value: "",
    name: "Any Type",
  },
  {
    value: "multiple",
    name: "Multiple Choice",
  },
  {
    value: "boolean",
    name: "True / False",
  },
];

export default quizTypes;
